import { Col, Container,Row } from "reactstrap";

const NSS = () =>{
  return(
      <Container>
          <Row>
              <Col>
              <h3 style={{borderBottom:"2px solid #f03c02",paddingTop:50}}>National Service Scheme</h3> 
              <p>Sri Venkateswara University College of Engineering, Tirupati carries rightly the pride for having been one of the pioneering institution in implanting the N.S.S. It was introducedduring 1969-70.</p>

   
              <h4 style={{paddingTop:20}}>Objectives</h4>
              <ul>
                  <li>To promote personality development among students through community service.</li>
                  <li>To instill a sense of discipline among students</li>
                  <li>To make students physically fit for nation building activities.</li>
                  <li>To direct students energies to right causes.</li>
                  <li>To acquire leadership qualities and democratic attitude.</li>
                  <li>To practice National integration</li>
              </ul>
              
              <h4 style={{paddingTop:20}}>NSS Programme Officer</h4>
              <p>NSS Programme Officer was appointed by the principal of the college at present Dr. A Sreeneivasulu Reddy, Associate Professor Department of Mechanical Engineering is acting as college NSS Officer.</p>
              <h4 style={{paddingTop:20}}>Admission</h4>
              <p>Students who wish to join NSS should apply to the Programme Officer of the college.</p>
              <h4 style={{paddingTop:20}}>Activity</h4>
              <p>NSS volunteers will have the following activity</p>
              <ul>
                  <li>120 hours of service during an academic year</li>
                  <li>They have to work on Sundays and evenings to complete this target service.</li>
                  <li>One special camp in a year during vacation.</li>
                  <li>
Volunteers are provided with refreshment whenever they work.</li>
              </ul>
              <h4 style={{borderBottom:"2px solid #f03c02",paddingTop:20}}>Issue of certificates</h4> 
              <ul>
                  <li>
                  Special Camp Certificates are issued to the volunteers who have been involved inthe camp for 10 days with Programme Coordinator's and Vice Chancellor's signatures.
                  </li>
                  <li>Bonafide N.S.S. Certificates are given to volunteers who have been involved in generalregular N.S.S. for 2 Years</li>
                  <li>
                  For volunteers who attend National Integration Camps, Inter State Camps, Inter Campson deputation, are given University certificate by the organisers of the camp.
                  </li>
              </ul>
              
              </Col>
          </Row>
      </Container>
  )
}
export default NSS;
